import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import * as EnvConstants from '../Constants/EnvConstants';
import VisitorParamsContext from '../Contexts/VisitorParams';
import {
  AddPouchDBData,
  GetPouchDBData,
  ClearAllPouchDBData,
} from './pouchdbService';
// import useIndexedDBData from "../Hooks/useIndexedDBData";
import usePouchDBData from '../Hooks/usePouchDBData';
import { v1 } from 'uuid';

export const UUID = () => {
  let local_storage_uuid = usePouchDBData('uuid');
  const urlParams = new URLSearchParams(window.location.search);
  //document.title = EnvConstants.AppTitle;
  const referrer = document.referrer;
  const { visitorParameters } = useContext(VisitorParamsContext);
  const full_url = window.location.href;
  const query_string_arr = full_url.split('?');
  const history = useHistory();
  var check_uuid = '';
  if (typeof query_string_arr[1] !== 'undefined') {
    check_uuid = urlParams.get('uuid');
  }
  const setExpiry = async () => {
    var hours = 24;
    var now = new Date().getTime();
    var setupTime = await GetPouchDBData('setupTime');

    if (setupTime == null) {
      await AddPouchDBData('setupTime', now);
    } else {
      if (now - setupTime > hours * 60 * 60 * 1000) {
        ClearAllPouchDBData();
        await AddPouchDBData('setupTime', now);
      }
    }
  };
  const getUUID = async (split_name, type) => {
    let uuids = '';
    if (type == 'check') {
      let local_storage_split_name = await GetPouchDBData('splitName');
      if (check_uuid) {
        uuids = urlParams.get('uuid');
      } else if (local_storage_uuid !== null) {
        var pixel = urlParams.get('pixel');
        var tracker = urlParams.get('tracker');
        let local_storage_tracker = await GetPouchDBData('tracker_type');
        let local_storage_tracker_unique_id =
          await GetPouchDBData('tracker_unique_id');

        if (pixel != null || tracker != null) {
          if (
            local_storage_tracker_unique_id != pixel ||
            local_storage_tracker != tracker ||
            local_storage_split_name != split_name
          ) {
            uuids = '';
          } else {
            uuids = local_storage_uuid;
          }
        } else {
          if (local_storage_split_name != split_name) {
            uuids = '';
          } else if (
            local_storage_split_name == split_name &&
            local_storage_tracker_unique_id != 'UNKNOWN' &&
            local_storage_tracker != 'UNKNOWN'
          ) {
            uuids = '';
          } else {
            uuids = local_storage_uuid;
          }
        }
      } else {
        uuids = '';
        if (typeof query_string_arr[1] !== 'undefined') {
          await AddPouchDBData('tracker_type', urlParams.get('tracker'));
          await AddPouchDBData('tracker_unique_id', urlParams.get('pixel'));
        } else {
          await AddPouchDBData('tracker_type', 'UNKNOWN');
          await AddPouchDBData('tracker_unique_id', 'UNKNOWN');
        }
      }
    } else {
      uuids = '';
    }
    if (uuids == '') {
      // uuids = EnvConstants.AppAdtopiaUPID + '-' + v1();
      uuids = 'RSFM120' + '-' + v1();
      ClearAllPouchDBData();
    }
    return uuids;
  };

  const setParams = (uuid, split_name) => {
    AddPouchDBData('uuid', uuid);
    AddPouchDBData('splitName', split_name);
    if (typeof query_string_arr[1] !== 'undefined') {
      if (urlParams.get('pixel') != null || urlParams.get('tracker') != null) {
        AddPouchDBData('tracker_type', urlParams.get('tracker'));
        AddPouchDBData('tracker_unique_id', urlParams.get('pixel'));
      }
    } else {
      AddPouchDBData('tracker_type', 'UNKNOWN');
      AddPouchDBData('tracker_unique_id', 'UNKNOWN');
    }
    const uuid_check = urlParams.get('uuid');
    var url = window.location.href;
    if (url.indexOf('?') != -1 && !uuid_check) {
      window.history.pushState(
        {},
        '',
        '?' + query_string_arr[1] + '&uuid=' + uuid
      );
    } else if (url.indexOf('?') === -1 && !uuid_check) {
      window.history.pushState({}, '', '?uuid=' + uuid);
    }
  };

  const fetchUuid = () => {
    const visitorData = visitorParameters.visitor_parameters;
    let uuid = null;
    if (visitorData && visitorData.uuid) {
      uuid = visitorData.uuid;
    } else {
      const query_uuid = urlParams.get('uuid');
      if (query_uuid === undefined || query_uuid === null || query_uuid == '') {
        uuid = local_storage_uuid;
      } else {
        uuid = query_uuid;
      }
    }
    return uuid;
  };
  return { getUUID, setExpiry, setParams, fetchUuid };
};
